export default {
  errorTitle: {
    id: 'checkout_services_root_error_title',
    defaultMessage: 'Something went wrong',
  },
  errorContent: {
    id: 'checkout_services_root_error_content',
    defaultMessage:
      'We couldn’t continue with your mobile plan setup. Please go back to cart and try again.',
  },
  backToCart: {
    id: 'checkout_services_root_error_back_to_cart',
    defaultMessage: 'Go back to cart',
  },
}
